import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import { ExamV3Tem } from "@/lib/model/exambuilder/exam-v3/exam-v3";

export class StructDimensionV2 extends Model {
  dimensionKey = ""; // 维度键
  dimensionName = ""; // 维度名
  dimensionDesc = ""; // 维度描述
  dimensionParentGroupId = 0; // 维度父级分类id
  dimensionParentGroupName = ""; // 维度父级分类名称
  isSystemDimension = 0; // 是否是标准维度 ==1标准维度 !=1私有维度
  isFromSystemDimension = 0; // 私有维度是否来自于旧逻辑下的公有维度 ==1 是 !=1不是
  questionCount = 0; // 当前维度题库题目数量(面试场景无数据)
  questionsIsExamUsed = 0; // 维度下是否有题目被面试使用(面试场景无数据)
}

export class ListCommonRequest {
  returnAll = true; // 是否返回全量 忽略分页 仅部分接口生效
  page = 1; //页码 默认1
  pageSize = 50; //页大小 [1-100] 默认10
}
export class TemplateList extends Model {
  list: ExamV3Tem[] = [new ExamV3Tem()];
  static get(listCommonRequest: ListCommonRequest) {
    return request
      .post("/aiExam/template/list", listCommonRequest)
      .then(resp => {
        const result = new TemplateList().assign(resp.data.data);
        return result;
      });
  }

  static tacGet(tacToken: string, templateName: string) {
    return request
      .post("tac/template/list", {
        features: { templateName },
        tacToken,
        countOnly: true
      })
      .then(resp => {
        return resp.data.data;
      });
  }
}
